<template>
    <tr>
        <td>
            <router-link class="mb-0 list-inline" :to="'/badge/' + badge.id">
                {{ badge.ref }}
            </router-link>
        </td>
        <td>
            <router-link class="mb-0 list-inline" :to="'/badge/' + badge.id">
                # {{ badge.number }}
            </router-link>
        </td>
        <td v-if="!updatingData">
            <span v-if="badge.lastName != null">
                {{ badge.lastName }}
            </span>
            <span v-else class="text-black-50 fst-italic">
                Non renseigné
            </span>
        </td>
        <td v-else>
            <input v-model="newLastName" type="text" class="form-control" placeholder="Nouveau nom">
        </td>
        <td v-if="!updatingData">
            <span v-if="badge.firstName != null">
                {{ badge.firstName }}
            </span>
            <span v-else class="text-black-50 fst-italic">
                Non renseigné
            </span>
        </td>
        <td v-else>
            <input v-model="newFirstName" type="text" class="form-control" placeholder="Nouveau nom">
        </td>
        <td v-if="!updatingData">
            <span v-if="badge.profile.name != null">
                {{ badge.profile.name }}
            </span>
            <span v-else class="text-black-50 fst-italic">
                Aucun profil
            </span>
        </td>
        <td v-else>
            <select v-model="newProfileId" class="form-select">
                <option v-for="profile in profiles"
                    :key="profile.id"
                    :value="profile.id">
                    {{ profile.name }}
                </option>
            </select>
        </td>
        <td>
            <InfoDisplay
            :icon="badge.disabled ? 'cross' : 'check'"
            :color="badge.disabled ? 'red' : 'green'"
            :toolTip="badge.disabled ? 'Désactivé' : 'Actif'"
            :size="'xl'" />
        </td>
        <td v-if="!updatingData" class="text-end">
            <div class="me-4">
                <a data-bs-toggle="dropdown" href="#" class="btn p-1" aria-expanded="false">
                    <font-awesome-icon :icon="['fas', 'bars']"/>
                </a>
                <div class="dropdown-menu dropdown-menu-end" style="">
                    <a role="button" v-on:click="updatingData = true" class="dropdown-item">Modifier</a>
                    <a v-if="badge.disabled" role="button" v-on:click="this.enable()" class="dropdown-item">Activer</a>
                    <a v-else role="button" v-on:click="this.disable()" class="dropdown-item">Désactiver</a>
                </div>
            </div>
        </td>
        <td v-else class="text-end">
            <ButtonDisplay
            :type="'save'"
            @click="this.save(); updatingData = false" />
            <ButtonDisplay
            :type="'cancel'"
            @click="updatingData = false" />
        </td>
    </tr>
</template>

<script>
import InfoDisplay from '@/components/display/InfoDisplay.vue'
import ButtonDisplay from '@/components/display/ButtonDisplay.vue'

export default {
    props: ['badge', 'profiles'],
    components: {
        InfoDisplay,
        ButtonDisplay
    },
    data() {
        return {
            updatingData: false,
            newFirstName: null,
            newLastName: null,
            newProfile: null
        };
    },
    mounted() {
        this.newFirstName = this.badge.firstName;
        this.newLastName = this.badge.lastName;
        this.newProfileId = this.badge.profile.id;
    },
    methods: {
        save() {
            this.$emit("save", {id: this.badge.id, firstName: this.newFirstName, lastName: this.newLastName, profile: this.newProfileId});
        },
        disable() {
            this.$emit("save", {id: this.badge.id, disabled: true});
        },
        enable() {
            this.$emit("save", {id: this.badge.id, disabled: false});
        }
    }
}
</script>